import { lazy } from "react";

const ClientAccountPage      = lazy(() => import("../pages/Home/ClientAccountPage"));
const ClientBillingPage      = lazy(() => import("../pages/Home/ClientBillingPage"));
const ClientInvoicesPage     = lazy(() => import("../pages/Home/ClientInvoicesPage"));
const ClientSubscriptionPage = lazy(() => import("../pages/Home/ClientSubscriptionPage"));

const routes = [
  { path: "/home",                        element: lazy(() => import("../pages/Home")) },
  // Account section — Org Details (includes Org Details + Contact + GST)
  { path: "/client/account",              element: ClientAccountPage },
  // Payments & Billing
  { path: "/client/account/billing",      element: ClientBillingPage },
  // Invoices
  { path: "/client/account/invoices",     element: ClientInvoicesPage },
  // Subscription section
  { path: "/client/subscription/app",     element: ClientSubscriptionPage },
  { path: "/client/subscription/module",  element: ClientSubscriptionPage },
  { path: "/client/subscription/page",    element: ClientSubscriptionPage },
  // Settings section
  { path: "/client/settings/users",       element: lazy(() => import("../pages/Home/ClientPage")) },
];

export default routes;
